import React from 'react';
import Footer from '../../Shared/Footer/Footer';

const Contuct = () => {
    return (
        <>
            <section className="text-gray-600 body-font relative my-5   ">
                <div className="container  mx-auto max-w-5xl bg-gray-100 rounded-2xl">
                    <div className="flex flex-col text-center w-full mb-12">
                        <span className="text-3xl font-bold border-b-2 w-44 mx-auto border-green-500 sm:text-3xl title-font mt-8 mb-4 text-gray-900">Contact Us</span>
                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">We will answer your any question.</p>
                    </div>
                    <div className="lg:w-1/2 md:w-2/3 mx-auto">
                        <div className="flex flex-wrap -m-2">
                            <div className="p-2 w-full">
                                <div className="relative">
                                    <label for="name" className="leading-7 text-sm text-gray-600 font-bold">Name</label>
                                    <input type="text" id="name" name="name" className="w-full bg-gray-100 bg-opacity-50 rounded border-2 border-gray-300 focus:border-green-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                                </div>
                            </div>
                            <div className="p-2 w-full">
                                <div className="relative">
                                    <label for="email" className="leading-7 font-bold text-sm text-gray-600">Email</label>
                                    <input type="email" id="email" name="email" className="w-full bg-gray-100 bg-opacity-50 rounded border-2 border-gray-300 focus:border-green-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                                </div>
                            </div>
                            <div className="p-2 w-full">
                                <div className="relative">
                                    <label for="message" className="leading-7 font-bold text-sm text-gray-600">Message</label>
                                    <textarea id="message" name="message" className="w-full bg-gray-100 bg-opacity-50 rounded border-2 border-gray-300 focus:border-green-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"></textarea>
                                </div>
                            </div>
                            <div className="p-2 w-full">
                                <button className="flex mx-auto mb-10 text-white bg-green-500 border-0 py-2 px-8 focus:outline-none hover:bg-green-600 rounded text-lg">Submit</button>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contuct;